import React from 'react'
const City = () => {
  return (
    <header className='headerEditor'><h2>City</h2></header>
  )
}

export default City